import { passThroughAxios } from './passThrough.axios'
import FileUploadApi from './FileUpload.api.js'

export default {
  getAllAddenda() {
    return passThroughAxios.get('addenda')
  },

  getAddendumById(addendumId) {
    return passThroughAxios.get(`addenda/${addendumId}`)
  },

  async createAddendum(file, fields) {
    const { token } = await FileUploadApi.uploadToStaging(file)
    return passThroughAxios.post('addenda', {
      fileToken: token,
      brandCode: fields.brandCode,
      dealerId: fields.dealerId,
      ponCatalogCarPattern: fields.ponCatalogCarPattern,
      optionCode: fields.optionCode,
      stock: fields.stock,
      dateFrom: fields.dateFrom,
      dateTo: fields.dateTo,
    })
  },

  async updateAddendum(addendumId, file, fields) {
    const body = {
      brandCode: fields.brandCode,
      dealerId: fields.dealerId,
      ponCatalogCarPattern: fields.ponCatalogCarPattern,
      optionCode: fields.optionCode,
      stock: fields.stock,
      dateFrom: fields.dateFrom,
      dateTo: fields.dateTo,
    }
    if (file != null) {
      const { token } = await FileUploadApi.uploadToStaging(file)
      body.fileToken = token
    }
    return passThroughAxios.put(`addenda/${addendumId}`, body)
  },

  deleteAddendum(addendumId) {
    return passThroughAxios.delete(`addenda/${addendumId}`)
  },
}
